import React from 'react';

import { H1, H2, Preamble, Paragraph, Link } from '@aurora/widgets-react';
import { OpenOutline } from '@aurora/icons-react';

import CodeSample from '../components/CodeSample';

const CodeExamples = () => (
  <React.Fragment>
    <H1>Code Examples</H1>

    <Preamble>
      This page provides basic code examples in python and javascript. They
      should help you get started but must probably be modified to fit your
      specific need.
    </Preamble>

    <H2>Python</H2>
    <Paragraph>
      This example uses the{' '}
      <Link to="https://docs.python-requests.org/en/latest/">
        requests <OpenOutline />
      </Link>{' '}
      library which is a very popular HTTP Client in python.
    </Paragraph>

    <CodeSample
      componentString={`import os
import sys
import requests

def get_error_reason(response):
    try:
        return response.json()['message']
    except Exception:
        return 'Could not get reason...'

customernr = os.getenv('SMHI_CUSTOMERNR')
secret = os.getenv('SMHI_SECRET')

auth_response = requests.post(
    'https://enlossws.smhi.se/api/auth/login',
    auth=(customernr, secret),
)

if auth_response.status_code != 201:
    reason = get_error_reason(auth_response)
    print(f'Could not get the access token. Reason: {reason}')
    sys.exit(1)

access_token = auth_response.json()['accessToken']

headers = {'Authorization': f'Bearer {access_token}'}
query_params = {
    'placenr': 102612,
    'parameternrs': [5, 316],
    'typecasenr': 1016,
}

data_response = requests.get(
    'http://enlossws.smhi.se/api/history',
    params=query_params, headers=headers,
)

if data_response.status_code != 200:
    reason = get_error_reason(data_response)
    print(f'Could not get any data. Reason: {reason}')
    sys.exit(1)

body = data_response.json()
starttimes = body['starttimes']
temperature = body['5']
cooling_index = body['316']

# Do something with starttimes, temperature and cooling_index...
`}
      language="python"
    />

    <H2>javascript</H2>

    <Paragraph>
      This example is indented to be used in a fronted. According to the
      frontend recommendations in{' '}
      <Link to="/authentication">Authentication</Link> it assumes there exists a
      route to fetch the access token directly. The access token could also be
      stored in local storage or some other state storage.
    </Paragraph>

    <CodeSample
      componentString={`fetch('https://pathtoourbackend.com/get_access_token')
  .then(response => response.json())
  .then(body => {
    const accessToken = body.accessToken
    const headers = {Authorization: 'Bearer ' + accessToken}
    const url = 'https://enlossws.smhi.se/api/history?placenr=102612&parameternrs=5'
    return fetch(url, {headers})
  })
  .then(callbackToDoSomethingWithTheResponse)
  .catch(e => {
    // Something went wrong...
  })

`}
      language="javascript"
    />
  </React.Fragment>
);

export default CodeExamples;
